import classNames from 'classnames';
import type { IFieldProps } from '../elements/Field';
import type { FormContextProps } from '../elements/formContext';
import { translateKey } from '../../translate';
import { Feedback } from '../elements/common';
import { Field } from '../elements/Field';
import { FormContextConsumer } from '../elements/formContext';

interface ITriStateInputProps {
    automation?: string;
    className?: string;
    error?: string;
    name: string;
    notNullable?: boolean;
    onChange: (value: boolean | null) => void;
    onDoValidate?: () => Promise<void>;
    tabIndex?: number;
    value: boolean | null;
}

export function TriStateInput(props: FormContextProps<ITriStateInputProps>) {
    return (
        <FormContextConsumer {...props}>
            {(properties) => (
                <>
                    <div className={classNames('toggle-group', props.className || '')}>
                        <label
                            className="toggle-group__btn"
                            data-dd-privacy="allow"
                        >
                            <input
                                checked={properties.value === true}
                                name={properties.name}
                                onChange={async () => {
                                    await properties.onChange(true);
                                    if (properties.onDoValidate) {
                                        await properties.onDoValidate();
                                    }
                                }}
                                onClick={async () => {
                                    if (!properties.notNullable && properties.value === true) {
                                        await properties.onChange(null);
                                        if (properties.onDoValidate) {
                                            await properties.onDoValidate();
                                        }
                                    }
                                }}
                                tabIndex={props.tabIndex}
                                type="radio"
                                value="yes"
                            />
                            <span
                                className={classNames(
                                    'toggle-group__label',
                                    props.automation ? 'automation-' + props.automation + 'Yes' : ''
                                )}
                            >
                                {translateKey('common.yes')}
                            </span>
                        </label>
                        <label className="toggle-group__btn">
                            <input
                                checked={properties.value === false}
                                name={properties.name}
                                onChange={async () => {
                                    await properties.onChange(false);
                                    if (properties.onDoValidate) {
                                        await properties.onDoValidate();
                                    }
                                }}
                                onClick={async () => {
                                    if (!properties.notNullable && properties.value === false) {
                                        await properties.onChange(null);
                                        if (properties.onDoValidate) {
                                            await properties.onDoValidate();
                                        }
                                    }
                                }}
                                type="radio"
                                value="no"
                            />
                            <span
                                className={classNames(
                                    'toggle-group__label',
                                    props.automation ? 'automation-' + props.automation + 'No' : ''
                                )}
                            >
                                {translateKey('common.no')}
                            </span>
                        </label>
                    </div>
                    <Feedback error={properties.error} />
                </>
            )}
        </FormContextConsumer>
    );
}

export function TriStateField(props: FormContextProps<ITriStateInputProps & IFieldProps>) {
    return (
        <Field {...props}>
            <TriStateInput {...props} />
        </Field>
    );
}
